The types of events to retrieve.

See `Event` implementations for a list of supported values.
